module.exports = __webpack_public_path__ + "static/img/gb.d3ddd602.svg";